/* Shopping assistant loader. Upload this file once to Shopify's Files and reference it from
 * theme.liquid; it fetches the current widget from the API endpoint on every page load,
 * so widget updates never need another theme or Files change. The fetch carries the
 * header that lets a free ngrok tunnel answer without its warning page.
 *
 *   <script src="{{ 'shopassist-loader.js' | file_url }}" data-endpoint="https://HOST" data-brand="..." defer></script>
 */
(function () {
  'use strict';
  var script = document.currentScript;
  if (!script || window.__shopAssistLoaded) return;
  var endpoint = String(script.dataset.endpoint || '').replace(/\/+$/, '');
  if (!endpoint) return;
  fetch(endpoint + '/widget.js', { headers: { 'ngrok-skip-browser-warning': '1' }, credentials: 'omit' })
    .then(function (r) {
      if (!r.ok) throw new Error('widget ' + r.status);
      return r.text();
    })
    .then(function (code) {
      var tag = document.createElement('script');
      Object.keys(script.dataset).forEach(function (key) {
        tag.dataset[key] = script.dataset[key];
      });
      tag.dataset.endpoint = endpoint;
      tag.text = code;
      document.body.appendChild(tag);
    })
    .catch(function () {
      /* the assistant simply does not appear when its API is down */
    });
})();
